export default __webpack_public_path__ + "static/media/q8_v2.72fcd347.png";